import { styled } from "@linaria/react"


import { MessageText } from "@/components/Chat/MessageStyles.ts"
import { StreamedTextBlock } from "@/components/Chat/StreamedTextBlock.tsx"
import { ReasoningResult_Diff } from "@/components/ReasoningStep/ReasoningResult_Diff.tsx"
import { ReasoningResult_Message } from "@/components/ReasoningStep/ReasoningResult_Message.tsx"
import { ReasoningResult_ScriptDiff } from "@/components/ReasoningStep/ReasoningResult_ScriptDiff.tsx"
import { ReasoningResult_SshCommand } from "@/components/ReasoningStep/ReasoningResult_SshCommand.tsx"
import { ReasoningResult_TodoList } from "@/components/ReasoningStep/ReasoningResult_TodoList.tsx"

import type { AiChatMessageAgentIterationStep, UUIToolCallObservation } from "@/lib/client/generated/TypeDefinitions.ts"


export const ReasoningStep = (props: {
  step: AiChatMessageAgentIterationStep,
  taskId: string,
  isRunning: boolean
}) => {
  const reasoning = props.step.reasoning
  const result = props.step.result

  if (!result && !reasoning) {
    return null
  }

  return (
    <>
      {reasoning && (
        <Reasoning>
          <StreamedTextBlock
            text={reasoning}
            isNew
            isStreamCompleted
            isStreamed={false}
          />
        </Reasoning>
      )}
      {result && (
        <ReasoningSecondLevelText>
          <ReasoningResultChooser
            result={result}
            taskId={props.taskId}
            inProgress={props.step.inProgress && props.isRunning}
          />
        </ReasoningSecondLevelText>
      )}
    </>
  )
}

const ReasoningResultChooser = (props: {
  result: UUIToolCallObservation,
  taskId: string,
  inProgress: boolean
}) => {
  if (props.result.className === "Message") {
    return <ReasoningResult_Message content={props.result} inProgress={props.inProgress} />
  }

  if (props.result.className == "ScriptDiff") {
    return <ReasoningResult_ScriptDiff content={props.result} />
  }

  if (props.result.className === "Diff") {
    return <ReasoningResult_Diff content={props.result} />
  }

  if (props.result.className === "SshCommand") {
    return <ReasoningResult_SshCommand content={props.result} inProgress={props.inProgress} taskId={props.taskId} />
  }

  if (props.result.className === "TodoList") {
    return <ReasoningResult_TodoList content={props.result} />
  }
}

const Reasoning = styled(MessageText)`
  margin-top: 16px;
`

const ReasoningSecondLevelText = styled.div`
  margin-top: 4px;
`